import { API } from "aws-amplify";

const verificationStatus = {
  success: "success",
};

const createTransaction = async ({
  order,
  subject,
  amount,
  paymentOption,
  marketplaceId,
  urlReturn,
  paramsNotify,
}) => {
  try {
    const init = {
      body: {
        order,
        subject,
        amount,
        paymentOption,
        marketplaceId,
        urlReturn,
        paramsNotify,
      },
    };

    const result = await API.post("paykuapi", "/transaction", init);

    if (result.error) {
      return result.error;
    } else {
      return result;
    }
  } catch (err) {
    return { error: { message: err.message, stack: err.stack } };
  }
};

const verifyTransaction = async (transactionId) => {
  try {
    const init = {
      body: {
        transactionId,
      },
    };

    const result = await API.post("paykuapi", "/transaction", init);

    if (result.error) {
      return result.error;
    } else {
      return result;
    }
  } catch (err) {
    return { error: { message: err.message, stack: err.stack } };
  }
};

export { verificationStatus, createTransaction, verifyTransaction };
